module.exports = __webpack_public_path__ + "static/media/rectangle.1d663f78.svg";